export const SET_PATIENT = 'SET_PATIENT'
export const SET_APPOINTMENT = 'SET_APPOINTMENT'
